import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { userHasAllRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next";

export default {
  props: {
    position: String,
  },
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      collectionCount: this.$store.state.collectForDownload.length,
      active: "",
      duplicateError: 0,
      activeMenu: "",
      activeLink: "",
      menus: {
        fileMenu: {
          urls: [
            `/home`,
            `/bin`,
            `/expanded/`,
            `/testfiles`,
            `/collections`,
            `/myspace`,
            `/myspace/expanded/`,
            `/collection/expanded/`,
            `/collect-for-download`,
            `/search`,
            `/notifications-overview`,
          ],
          links: {
            spaces: {
              name: i18n.tc("spaces.space", 2),
              url: `/${this.$store.state.company}/home`,
              activeUrls: ["/expanded/"],
              icon: "space",
              rights: [],
            },
            mySpace: {
              name: i18n.t("main_menu.my_space"),
              url: `/${this.$store.state.company}/myspace`,
              activeUrls: ["/myspace/expanded/"],
              icon: "myspace",
              rights: ["my-space"],
            },
            collectForDownload: {
              name: i18n.t("collection.download_collection"),
              url: `/${this.$store.state.company}/collect-for-download`,
              activeUrls: ["/collection/expanded/", "/collect-for-download"],
              icon: "collection",
              counter: "collectionCount",
              rights: ["collect", "!user"],
            },
            collections: {
              name: i18n.tc("collection.collection", 2),
              url: `/${this.$store.state.company}/collections`,
              activeUrls: ["/collection/expanded/"],
              icon: "collection",
              rights: ["collect", "user"],
            },
          },
          bottomLinks: {
            bin: {
              name: "bin",
              url: `/${this.$store.state.company}/bin`,
              activeUrls: ["/bin/"],
              icon: "delete--alt",
              rights: [],
            },
          },
        },
        settingsMenu: {
          urls: [`/account`, `/branding`, `/billing`, `/plan`, `/users`],
          links: {
            account: {
              name: i18n.t("settings_menu.account"),
              url: `/${this.$store.state.company}/account`,
              activeUrls: [],
              icon: "account",
              rights: [],
            },
            branding: {
              name: i18n.t("settings_menu.branding"),
              url: `/${this.$store.state.company}/branding`,
              activeUrls: [],
              icon: "branding",
              rights: ["edit_branding"],
            },
            users: {
              name: i18n.tc("settings_menu.manage_user", 2),
              url: `/${this.$store.state.company}/users`,
              activeUrls: [],
              icon: "users",
              rights: ["add_users", "edit_users", "delete_users", "edit_roles"],
            },
            billing: {
              name: i18n.t("settings_menu.plan_and_billing"),
              url: `/${this.$store.state.company}/billing`,
              activeUrls: [],
              icon: "euro",
              rights: ["Administrator"],
            },
            privacy: {
              name: i18n.t("settings_menu.privacy_and_legal"),
              url: `/${this.$store.state.company}/policy`,
              activeUrls: [],
              icon: "privacy-legal",
              rights: [],
            },
            back: {
              name: i18n.t("settings_menu.back_to_spaces"),
              url: `/${this.$store.state.company}/home`,
              activeUrls: [],
              icon: "back-arrow",
              rights: [],
            },
          },
        },
      },
    };
  },
  created() {
    //this.showCollectedBadge();
    this.setActiveMenu();
  },

  methods: {
    counter(name) {
      return name ? this[name] : -1;
    },
    setActiveMenu() {
      Object.keys(this.menus).forEach((key) => {
        this.menus[key].urls.forEach((url) => {
          //check if url is in route
          if (typeof url === "string") {
            if (this.$route.path.indexOf(url) !== -1) {
              this.activeMenu = key;
            }
          } else {
            //has extra rules
            if (this.$route.path.indexOf(url.url) !== -1 && url.rule) {
              this.activeMenu = key;
            }
          }
        });
      });

      this.setActiveLink();
    },
    setActiveLink() {
      if (this.activeMenu !== "") {
        if (this.menus[this.activeMenu]) {
          const links =
            this.position === "bottom"
              ? this.menus[this.activeMenu].bottomLinks
              : this.menus[this.activeMenu].links;

          Object.keys(links).forEach((linkKey) => {
            if (
              links[linkKey].activeUrls.filter((url) =>
                this.$route.path.includes(url)
              ).length ||
              this.$route.path.indexOf(links[linkKey].url) !== -1
            ) {
              //is active link
              this.activeLink = linkKey;
            }
          });
        }
      }
    },
    isActiveLink(linkKey) {
      return linkKey === this.activeLink;
    },
    openLink(url) {
      //close actions
      EventBus.$emit(`closeallactions`);

      this.$router.push(url);
    },
    /**
     * Open Collected (Collect for download)
     */
    openCollected() {
      this.$router.push("/" + this.company + "/collect-for-download");
      this.active = "collected";
    },
    /**
     * Show Collected bagdge
     */
    showCollectedBadge() {
      let $collectionCountOld = this.collectionCount;
      let $collectionCountNew = "";
      let $badge = document.querySelector(".collection--badge.active");
      let $count = document.querySelector(
        ".collection--badge.active .collection--badge--count"
      );

      if (this.user) {
        this.$axios
          .get(baseUrl + "/collectionscount?myspace" + this.mySpace)
          .then((response) => {
            $collectionCountNew = response.data;
          });
      } else {
        let collectedItems = localStorage.getItem(
          this.$store.state.company + "_collect_for_download"
        );
        if (collectedItems) {
          collectedItems = JSON.parse(collectedItems);
        } else {
          collectedItems = [];
        }
        $collectionCountNew = collectedItems.length;
      }

      if (
        $collectionCountNew != $collectionCountOld &&
        $collectionCountNew != 0 &&
        $collectionCountOld != 0
      ) {
        setTimeout(() => (this.collectionCount = $collectionCountNew), 300);

        if ($badge && $count) {
          $badge.style.transform = "scale(1.1)";
          $count.style.transition = "opacity .3s ease";
          $count.style.opacity = 0;

          setTimeout(() => ($badge.style.transform = "scale(1)"), 300);
          setTimeout(() => ($count.style.opacity = 1), 300);
        }
      } else if (
        $collectionCountNew != $collectionCountOld &&
        $collectionCountNew == 0
      ) {
        $badge.style.transition = "all .3s ease";
        this.collectionCount = $collectionCountNew;
        setTimeout(() => ($badge.style.tranistion = "none"), 300);
      } else {
        this.collectionCount = $collectionCountNew;
      }

      this.getRoute();
    },
    /**
     * Get the route to set the active state
     */
    getRoute() {
      let route = this.$router.currentRoute.path;
      route = route.split("/")[2];

      if (route == "home") {
        this.active = "spaces";
      } else if (route == "myspace") {
        this.active = "myspace";
      } else if (route == "collections") {
        this.active = "collections";
      } else if (route == "collect-for-download") {
        this.active = "collected";
      }
    },
    showError() {
      this.duplicateError = 1;
    },
    hideError() {
      this.duplicateError = 2;
    },
    checkRights(rights) {
      return userHasAllRights(rights, this);
    },
  },
  computed: {
    links() {
      return this.menus[this.activeMenu]
        ? this.position === "bottom"
          ? this.menus[this.activeMenu].bottomLinks
          : this.menus[this.activeMenu].links
        : [];
    },
  },
  watch: {
    $route() {
      this.setActiveLink();
    },

    "$store.state.collectForDownload"() {
      this.collectionCount = this.$store.state.collectForDownload.length;
      this.setActiveLink();
    },
  },
};
